import { User } from '@wellesley/openapi'
import { UserAvatar } from '@wellesley/user/components/UserAvatar'
import { SearchItem } from 'hooks/useArrowsNavigation'
import { getUserImage } from 'helpers/getUserImage'
import { getDisplayUsername } from '@wellesley/user/helpers/getDisplayUsername'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { flow } from 'lodash/fp'

import { getClearValue } from './getClearValue'

const formatUserName = flow(
  getUserNameWithDomain,
  getDisplayUsername,
  getClearValue,
)

export const mapAutocompleteUsers = (arr: User[]): SearchItem[] =>
  arr.map((user) => ({
    img: <UserAvatar name={user.displayName} imgUrl={getUserImage({ user })} />,
    displayName: user.displayName,
    name: formatUserName(user),
  }))

export const mapAutocompleteHashtags = (arr: string[]): SearchItem[] =>
  arr.map((tag) => ({ name: tag }))
